module.exports = __webpack_public_path__ + "static/MTS-55b43ef35d66d5363474d8ad571e3b74.webp";